/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_TitleInputs */

const en_admin_tickets_title = /** @type {(inputs: Admin_Tickets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Tickets`)
};

const zh_admin_tickets_title = /** @type {(inputs: Admin_Tickets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工单管理`)
};

/**
* | output |
* | --- |
* | "Support Tickets" |
*
* @param {Admin_Tickets_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_title = /** @type {((inputs?: Admin_Tickets_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_title(inputs)
	return zh_admin_tickets_title(inputs)
});
export { admin_tickets_title as "admin.tickets.title" }